import React from "react"
import Helmet from "react-helmet"
import PropTypes from "prop-types"
import { StaticQuery, graphql } from "gatsby"

const SEO = ({ title, description, image, pathname, article }) => (
  <StaticQuery
    query={query}
    render={({
      site: {
        siteMetadata: {
          defaultTitle,
          titleTemplate,
          defaultDescription,
          siteUrl,
          defaultImage,
          twitterUsername,
        },
      },
      allContactJson,
    }) => {
      const [contactData] = allContactJson.nodes;
      let imageVal = image || defaultImage
      if (imageVal && !imageVal.startsWith("http")) {
        imageVal = `${siteUrl}${imageVal}`
      }
      const seo = {
        title: title ? `${title} | ${defaultTitle}` : defaultTitle,
        description: description || defaultDescription,
        image: imageVal,
        url: `${siteUrl}${pathname || "/"}`,
      }

      return (
        <>
          <Helmet title={seo.title} titleTemplate={titleTemplate}>
            <meta name="description" content={seo.description} />
            <meta name="image" content={seo.image} />
            {seo.url && <meta property="og:url" content={seo.url} />}
            {(article ? true : null) && (
              <meta property="og:type" content="article" />
            )}
            {seo.title && <meta property="og:title" content={seo.title} />}
            {seo.description && (
              <meta property="og:description" content={seo.description} />
            )}
            {seo.image && <meta property="og:image" content={seo.image} />}
            <meta name="twitter:card" content="summary_large_image" />
            {twitterUsername && (
              <meta name="twitter:creator" content={twitterUsername} />
            )}
            {seo.title && <meta name="twitter:title" content={seo.title} />}
            {seo.description && (
              <meta name="twitter:description" content={seo.description} />
            )}
            {seo.image && <meta name="twitter:image" content={seo.image} />}
            <script type="application/ld+json">
              {`{
                "@context": "https://schema.org",
                "@type": "TattooParlor",
                "image": [
                  "${siteUrl}/images/home/1.jpg",
                  "${siteUrl}/images/home/2.jpg",
                  "${siteUrl}/images/home/3.jpg",
                ],
                "@id": ${siteUrl},
                "name": ${defaultTitle},
                "address": {
                  "@type": "PostalAddress",
                  "streetAddress": "Merghany St.",
                  "addressLocality": "Nasr City",
                  "addressRegion": "Cairo",
                  "postalCode": "11757",
                  "addressCountry": "EG"
                },
                "geo": {
                  "@type": "GeoCoordinates",
                  "latitude": 30.0880474,
                  "longitude": 31.3358606
                },
                "url": "${siteUrl}",
                "logo": "${siteUrl}/images/logo-large.jpg",
                "email": "${contactData.email}",
                "telephone": "${contactData.phone}",
                "knowsLanguage": "${contactData.knows_language}",
                "priceRange": "${contactData.price_range}",
                "paymentAccepted": "${contactData.payment_accepted}",
                "review": {
                  "@type": "Review",
                  "reviewBody": "Highly recommended 😍🙏 Done with passion and with great keen for the tiniest details in an absolute clean place 😍😍😍 Thanks so much dears ❤️❤️"
                  "reviewRating": {
                    "@type": "Rating",
                    "ratingValue": "5",
                    "bestRating": "5"
                  },
                  "author": {
                    "@type": "Person",
                    "name": "Mahy"
                  }
                }
              }`}
            </script>
          </Helmet>
        </>
      )
    }}
  />
)

// "openingHoursSpecification": [
//   {
//     "@type": "OpeningHoursSpecification",
//     "dayOfWeek": [
//       "Monday",
//       "Tuesday"
//     ],
//     "opens": "11:30",
//     "closes": "22:00"
//   },
//   {
//     "@type": "OpeningHoursSpecification",
//     "dayOfWeek": [
//       "Wednesday",
//       "Thursday",
//       "Friday"
//     ],
//     "opens": "11:30",
//     "closes": "23:00"
//   },
//   {
//     "@type": "OpeningHoursSpecification",
//     "dayOfWeek": "Saturday",
//     "opens": "16:00",
//     "closes": "23:00"
//   },
//   {
//     "@type": "OpeningHoursSpecification",
//     "dayOfWeek": "Sunday",
//     "opens": "16:00",
//     "closes": "22:00"
//   }
// ]

export default SEO

SEO.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.string,
  pathname: PropTypes.string,
  article: PropTypes.bool,
}

SEO.defaultProps = {
  title: null,
  description: null,
  image: null,
  pathname: null,
  article: false,
}

const query = graphql`
  query SEO {
    site {
      siteMetadata {
        defaultTitle: title
        titleTemplate
        defaultDescription: description
        siteUrl
        defaultImage: image
        twitterUsername
      }
    }
    allContactJson {
      nodes {
        id
        email
        phone
        price_range
        payment_accepted
        knows_language
      }
    }
  }
`
